import type { UserPermissions } from "common/types";

import Accounts from "./accounts/components";
import Campaigns from "./campaigns/components/Campaigns";
import Home from "./home/components/Home";
import Inbox from "./inbox/components/Inbox";
import Integrations from "./integrations/components/Integrations";
import Leads from "./leads/components/Leads";
import Lists from "./lists/components/Lists";
import Notifications from "./notifications/components/Notifications";
import Templates from "./templates/components/Templates";
import WorkspaceOnboarding from "./workspace-onboarding";
import WorkspaceSettings from "./workspace-settings/components/WorkspaceSettings";

import type { JSX } from "react";

interface WorkspaceRoute {
  path: string;
  component: JSX.Element;
  visibleForPermissions?: UserPermissions;
}

const workspaceRoutes: WorkspaceRoute[] = [
  {
    path: "home",
    component: <Home />,
  },
  {
    path: "campaigns/*",
    component: <Campaigns />,
    visibleForPermissions: ["campaigns_limited"],
  },
  {
    path: "lists/*",
    component: <Lists />,
    // TODO: gate behind a permission (e.g. lists_full) once one exists
  },
  {
    path: "leads/*",
    component: <Leads />,
    visibleForPermissions: ["leads_full"],
  },
  {
    path: "templates/*",
    component: <Templates />,
    visibleForPermissions: ["templates_limited"],
  },
  {
    path: "inbox",
    component: <Inbox />,
    visibleForPermissions: ["inbox_limited"],
  },
  {
    path: "settings/*",
    component: <WorkspaceSettings />,
  },
  {
    path: "notifications",
    component: <Notifications />,
  },
  {
    path: "onboarding",
    component: <WorkspaceOnboarding />,
  },
  {
    path: "accounts/*",
    component: <Accounts />,
    visibleForPermissions: ["accounts_limited"],
  },
  {
    path: "integrations",
    component: <Integrations />,
    visibleForPermissions: ["integrations_full"],
  },
] as const;

export { workspaceRoutes };
